import React from 'react';
import { Alert } from 'antd';

/**
 * TapdFieldFormItem 的错误边界组件
 * 防止单个字段渲染错误导致整个页面崩溃
 */
class TapdFieldFormItemErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('TapdFieldFormItem 渲染错误:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Alert
          message="字段渲染失败"
          description={`该字段暂不支持，请联系管理员。错误: ${this.state.error?.message || '未知错误'}`}
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
        />
      );
    }

    return this.props.children;
  }
}

export default TapdFieldFormItemErrorBoundary;
